<template>
    <div class="base-exam-container" v-loading="loading">
        <div class="base-exam-box">
            <div class="paper-head-box">
                <div class="paper-head-container">
                    <div class="l-side-paper-container">
                        <svg t="1775717777561" @click="backExamPaper('/jzedu/ques')" style="margin-top: 9px;" class="icon cursor" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5353" width="32" height="32"><path d="M404.032 233.344a32 32 0 1 1 45.248 45.312L247.872 480h605.44a32 32 0 0 1 31.488 26.24l0.512 5.76a32 32 0 0 1-32 32h-605.44l201.408 201.344a32 32 0 0 1 3.712 40.832l-3.712 4.48a32 32 0 0 1-45.248 0l-256-256-0.64-0.896-1.216-1.152-0.896-1.344-0.96-1.088-0.64-1.152-0.64-0.896-0.64-1.344-0.832-1.472-0.32-1.152-0.64-1.024-0.256-1.536-0.64-1.472-0.192-1.472-0.32-0.896-0.064-1.216-0.384-1.792V513.28L138.752 512l0.128-1.28v-1.472l0.32-1.856V506.24l0.384-0.96 0.192-1.408 0.64-1.536 0.32-1.472 0.576-1.088 0.32-1.088 0.896-1.536 0.576-1.28 0.64-0.96 0.64-1.088 0.96-1.152 0.896-1.28 1.216-1.216 0.64-0.832 256-256z" fill="#ff7f2e" p-id="5354"></path></svg>
                    </div>
                    <div class="mid-paper-container">组卷中心</div>
                    <div class="r-side-paper-container cursor">
                        <el-avatar style="margin-top: 7px;" :size="36" :src="userInfo.avatar + '?_=' + Date.now()" />
                    </div>
                </div>
            </div>
            <div class="exam-container">
                <div class="l-exam-container" :class="{'seal-on': optSeal}">
                    <!-- 装订线 -->
                    <img v-if="optSeal" class="seal-line-img" :src="sealLineImg" alt=""/>
                    <!-- 保密标记 -->
                    <div v-if="optMarkTag" class="paper-mark-tag">{{paperForm.markTag}}</div>
                    <!-- 试卷标题（点击编辑） -->
                    <div class="exam-title-container">
                        <span v-if="editingField!=='paperName'" class="cursor" title="点击修改试卷名称" @click="startEdit('paperName')">{{paperForm.paperName || '请点击输入试卷名称'}}</span>
                        <el-input v-else ref="editInput" v-model="paperForm.paperName" class="edit-input title-edit-input"
                                  @blur="editingField=''" @keyup.enter="editingField=''"/>
                    </div>
                    <!-- 副标题 -->
                    <div class="paper-sub-title" v-if="optSubTitle">
                        <span v-if="editingField!=='subTitle'" class="cursor" title="点击修改副标题" @click="startEdit('subTitle')">{{paperForm.subTitle}}</span>
                        <el-input v-else ref="editInput" v-model="paperForm.subTitle" class="edit-input"
                                  @blur="editingField=''" @keyup.enter="editingField=''"/>
                    </div>
                    <!-- 试卷信息 -->
                    <div class="paper-test-info" v-if="optTestInfo">
                        <span v-if="editingField!=='testInfo'" class="cursor" title="点击修改试卷信息" @click="startEdit('testInfo')">{{paperForm.testInfo}}</span>
                        <el-input v-else ref="editInput" v-model="paperForm.testInfo" class="edit-input"
                                  @blur="editingField=''" @keyup.enter="editingField=''"/>
                    </div>
                    <!-- 考生信息 -->
                    <div class="paper-student-info" v-if="optStudentInfo">
                        <span v-if="editingField!=='studentInfo'" class="cursor" title="点击修改考生信息" @click="startEdit('studentInfo')">{{paperForm.studentInfo}}</span>
                        <el-input v-else ref="editInput" v-model="paperForm.studentInfo" class="edit-input"
                                  @blur="editingField=''" @keyup.enter="editingField=''"/>
                    </div>
                    <!-- 总分栏 -->
                    <div class="total-score-box" v-if="optScore">
                        <table class="score-table">
                            <tr>
                                <td>题号</td>
                                <td v-for="(g,gi) in paperForm.groups" :key="'h'+gi">{{cnums[gi]}}</td>
                                <td>总分</td>
                            </tr>
                            <tr>
                                <td>得分</td>
                                <td v-for="(g,gi) in paperForm.groups" :key="'b'+gi"></td>
                                <td></td>
                            </tr>
                        </table>
                    </div>
                    <!-- 注意事项 -->
                    <div class="paper-notice" v-if="optNotice">
                        <template v-if="editingField!=='notice'">
                            <div class="cursor" title="点击修改注意事项" @click="startEdit('notice')">
                                <div>注意事项：</div>
                                <div v-for="(line,li) in noticeList" :key="li">{{line}}</div>
                            </div>
                        </template>
                        <el-input v-else ref="editInput" v-model="paperForm.notice" type="textarea" :rows="3" class="edit-input"
                                  @blur="editingField=''"/>
                    </div>

                    <template v-for="(parItem,index) in quesClassifyList" :key="index">
                        <!-- 分卷及注释 -->
                        <template v-if="optPart && index===0">
                            <div class="part-head-title">
                                <span v-if="editingField!=='p00'" class="cursor" title="点击修改分卷标题" @click="startEdit('p00')">{{paperForm.partHeadList[0][0]}}</span>
                                <el-input v-else ref="editInput" v-model="paperForm.partHeadList[0][0]" class="edit-input"
                                          @blur="editingField=''" @keyup.enter="editingField=''"/>
                            </div>
                            <div class="part-head-note">
                                <span v-if="editingField!=='p01'" class="cursor" title="点击修改分卷说明" @click="startEdit('p01')">{{paperForm.partHeadList[0][1]}}</span>
                                <el-input v-else ref="editInput" v-model="paperForm.partHeadList[0][1]" class="edit-input note-edit-input"
                                          @blur="editingField=''" @keyup.enter="editingField=''"/>
                            </div>
                        </template>
                        <template v-if="optPart && paperForm.partHeadSeq>0 && index===paperForm.partHeadSeq">
                            <div class="part-head-title">
                                <span v-if="editingField!=='p10'" class="cursor" title="点击修改分卷标题" @click="startEdit('p10')">{{paperForm.partHeadList[1][0]}}</span>
                                <el-input v-else ref="editInput" v-model="paperForm.partHeadList[1][0]" class="edit-input"
                                          @blur="editingField=''" @keyup.enter="editingField=''"/>
                            </div>
                            <div class="part-head-note">
                                <span v-if="editingField!=='p11'" class="cursor" title="点击修改分卷说明" @click="startEdit('p11')">{{paperForm.partHeadList[1][1]}}</span>
                                <el-input v-else ref="editInput" v-model="paperForm.partHeadList[1][1]" class="edit-input note-edit-input"
                                          @blur="editingField=''" @keyup.enter="editingField=''"/>
                            </div>
                        </template>
                        <!-- 大题标题 -->
                        <div class="exam-classify-title">
                            <table v-if="optCateScore" class="cate-score-table">
                                <tr><td>评卷人</td><td>得&nbsp;分</td></tr>
                                <tr><td></td><td></td></tr>
                            </table>
                            <span>{{groupTitleText(index)}}</span>
                        </div>
                        <div class="exam-list-container">
                            <div class="exam-item" v-for="(item,indexs) in parItem.quesList" :key="item.ques.sid">
                                <!-- 试题内容 -->
                                <div class="pt1" >
                                    <span class="qseq">{{quesGlobalSeq(index,indexs)}}．</span>
                                    <a v-if="item.ques.label">{{item.ques.label}}</a>
                                    <span v-html="item.ques.content"></span>
                                </div>
                                <!-- 选项 -->
                                <div class="pt2" v-if="item.ques.options&&item.ques.options.length>0&&item.ques.options[0].length<10">
                                    <table style="width:100%" class="ques quesborder">
                                        <tr>
                                            <td style="width:23%" class="selectoption" v-for="(option,oIndexs) in item.ques.options" :key="oIndexs">
                                                <div class="cursor" v-if="oIndexs===0">A．<span v-html="option"></span></div>
                                                <div class="cursor"  v-if="oIndexs===1">B．<span v-html="option"></span></div>
                                                <div class="cursor"  v-if="oIndexs===2">C．<span v-html="option"></span></div>
                                                <div class="cursor"  v-if="oIndexs===3">D．<span v-html="option"></span></div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="pt2" v-if="item.ques.options&&item.ques.options.length>0&&item.ques.options[0].length>=10">
                                    <table style="width:100%" class="ques quesborder">
                                        <tr v-for="(option,oIndexs) in item.ques.options" :key="oIndexs">
                                            <td style="width:98%" class="selectoption" >
                                                <div class="cursor"  v-if="oIndexs===0">A．<span v-html="option"></span></div>
                                                <div class="cursor"  v-if="oIndexs===1">B．<span v-html="option"></span></div>
                                                <div class="cursor"  v-if="oIndexs===2">C．<span v-html="option"></span></div>
                                                <div class="cursor"  v-if="oIndexs===3">D．<span v-html="option"></span></div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <!-- 作答区 -->
                                <div class="answer-area" v-if="areaRows[item.ques.sid] > 0">
                                    <div class="answer-line" v-for="n in areaRows[item.ques.sid]" :key="n"></div>
                                </div>
                                <!-- 悬浮操作栏：分值 / 作答区行数 / 上移 / 下移 / 删除 -->
                                <div class="ques-hover-bar">
                                    <el-input-number v-model="findGroupQues(item.ques.sid).Score" :min="0" :step="0.5" :precision="1"
                                                     size="small" controls-position="right" style="width: 90px;"/>
                                    <span class="bar-unit">分</span>
                                    <span class="bar-label">插入作答区</span>
                                    <el-input-number v-model="areaRows[item.ques.sid]" :min="0" :max="30"
                                                     size="small" controls-position="right" style="width: 80px;"
                                                     @change="syncQuesAreas"/>
                                    <span class="bar-unit">行</span>
                                    <span class="bar-btn" :class="{'bar-btn-disabled': indexs===0}"
                                          @click="moveQues(index, indexs, -1)">上移</span>
                                    <span class="bar-btn" :class="{'bar-btn-disabled': indexs===parItem.quesList.length-1}"
                                          @click="moveQues(index, indexs, 1)">下移</span>
                                    <span class="bar-btn bar-btn-danger" @click="removeQues(index, indexs)">删除</span>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="r-exam-container">

                    <div class="exam-submit-container">
                        <div class="exam-submit-btn" @click="openPaperInfo">提交组卷</div>
                    </div>

                    <div class="exam-submit-container" style="margin-top: 10px;">
                        <div class="exam-submit-btn plain-btn" @click="viewPaper">我的组卷</div>
                    </div>

                    <!-- 组卷信息 -->
                    <div class="r-panel">
                        <div class="r-panel-title">
                            <span class="title-bar">组卷信息</span>
                            <el-checkbox v-model="isOpenBool">公开</el-checkbox>
                        </div>
                        <div class="r-panel-body">
                            <div class="paper-stat">
                                <span>难度：{{paperDegree}}</span>
                                <span class="paper-stat-score">分数：{{totalScore.toFixed(1)}}</span>
                                <span class="score-set-link cursor" @click="isShowScoreDialog = true">
                                    <el-icon><EditPen/></el-icon>分值设置
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- 卷参设置 -->
                    <div class="r-panel">
                        <div class="r-panel-title">
                            <span class="title-bar">卷参设置</span>
                            <span class="collapse-btn cursor" @click="paramCollapse=!paramCollapse">{{paramCollapse?'展开':'收起'}}</span>
                        </div>
                        <div class="r-panel-body" v-show="!paramCollapse">
                            <el-radio-group v-model="paperMode" @change="applyPaperMode">
                                <el-radio :value="0">简易</el-radio>
                                <el-radio :value="1">普通</el-radio>
                                <el-radio :value="2">正式</el-radio>
                            </el-radio-group>
                            <div class="param-check-list">
                                <el-checkbox v-model="optSubTitle">副标题</el-checkbox>
                                <el-checkbox v-model="optTestInfo">试卷信息</el-checkbox>
                                <el-checkbox v-model="optStudentInfo">考生信息</el-checkbox>
                                <el-checkbox v-model="optPart">分卷及注释</el-checkbox>
                                <el-checkbox v-model="optScore">总分栏</el-checkbox>
                                <el-checkbox v-model="optCateScore">大题评分区</el-checkbox>
                                <el-checkbox v-model="optSeal">装订线</el-checkbox>
                                <el-checkbox v-model="optNotice">注意事项</el-checkbox>
                                <el-checkbox v-model="optMarkTag">保密标记</el-checkbox>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <el-dialog title="提交组卷" v-model="isShowPaperDialog" width="400px">
            <el-form ref="paperFormRef" :rules="paperFormRules" :model="paperForm"
                     label-width="80px" class="meeting-form">
                <el-row style="width: 100%;">
                    <el-form-item  label="组卷名称" prop="paperName" style="width: 100%;">
                        <el-input v-model="paperForm.paperName" placeholder="请输入组卷名称，如'2025中考压轴题'" />
                    </el-form-item>
                </el-row>
                <el-row style="width: 100%;">
                    <el-form-item  label="考试时长" prop="times" style="width: 100%;">
                        <el-input-number v-model="paperForm.times" :min="1"  label="请输入考试时长" />
                    </el-form-item>
                </el-row>
                <el-row style="width: 100%;">
                    <el-form-item style="width: 100%;">
                        <el-button type="primary" @click="submitGeneratePaper">确定</el-button>
                        <el-button @click="isShowPaperDialog = !isShowPaperDialog">取消</el-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </el-dialog>

        <!--分值设置-->
        <el-dialog title="分值设置" v-model="isShowScoreDialog" width="450px" top="8vh">
            <div class="score-dialog-head">试卷总分：{{totalScore.toFixed(1)}}<span class="paper-stat-score">难度等级：{{paperDegree}}</span></div>
            <el-scrollbar max-height="55vh">
                <div v-for="(group,gi) in paperForm.groups" :key="gi" class="score-group">
                    <div class="score-group-title">
                        <span>{{group.Key}}（共{{group.Value.length}}小题<template v-if="groupFullScore(gi)>0">，满分{{groupFullScore(gi)}}分</template>）</span>
                        <el-button link type="primary" @click="oneKeySet(gi)">一键设置</el-button>
                    </div>
                    <el-table :data="group.Value" border size="small">
                        <el-table-column prop="Seq" label="题号" width="70" align="center"/>
                        <el-table-column label="难度" width="190" align="center">
                            <template #default="scope">{{ degreeLabel(degreeOf(scope.row.SID)) }}</template>
                        </el-table-column>
                        <el-table-column label="分值" width="170" align="center">
                            <template #default="scope">
                                <el-input-number v-model="scope.row.Score" :min="0" :step="0.5" :precision="1"
                                                 size="small" controls-position="right" style="width: 100px;"/>
                                <span class="bar-unit">分</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-scrollbar>
            <template #footer>
                <el-button type="primary" @click="isShowScoreDialog = false">确定</el-button>
                <el-button @click="isShowScoreDialog = false">取消</el-button>
            </template>
        </el-dialog>

        <!--组卷列表-->
        <el-dialog title="组卷列表" v-model="isShowPaperListDialog" width="800px">
            <el-table show-overflow-tooltip height="calc(100vh - 300px)"
                      border  highlight-current-row
                      :data="paperList">
                <el-table-column type="index" align="center" label="序号" width="60" />
                <el-table-column width="" align="center" label="组卷名称" prop="paperName">
                    <template #default="scope">
                        <div :title="scope.row.paperName" style="color: #409efe;" class="text-one cursor">
                            {{ scope.row.paperName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="90" align="center" label="考试时长（分钟）" prop="times">
                </el-table-column>
                <el-table-column width="80" align="center" label="总分" prop="score">
                </el-table-column>
                <el-table-column width="180" align="center" label="组卷时间" prop="createTime">
                    <template #default="scope">
                        <div>
                            {{ timestampToTime(scope.row.createTime) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" align="center" width="100">
                    <template #default="scope">
                        <el-button type="primary" size="small" @click="downloadPaperFile(scope.row)">
                            下载
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import {timestampToTime} from "@/utils/date";
import {jyeooDate} from "@/utils/str"
import {downloadFile} from "@/api/adminservice/public"
import {queryBasket, generatePaper, listPaper,downloadPaper, quesDelBasket} from "@/api/admin/paper";
import sealLineImg from "@/assets/exam/peal_line.png";

export default {
    name: "HomePaperCenter",
    components: {},
    data() {
        return {
            loading:true,
            isShowPaperDialog:false,
            isShowPaperListDialog:false,
            isShowScoreDialog:false,
            subjectEnName:'',
            sp:'',
            timestampToTime,
            jyeooDate,
            sealLineImg,
            userInfo : JSON.parse(this.$storage.get("userInfo")),
            basketInfo:{},
            basketQuesCount:0,
            basketQuesIds:"",
            quesClassifyList:[],// 试题分类列表
            quesNoList:[
              "一．", "二．", "三．", "四．","五．",
              "六．", "七．", "八．", "九．", "十．",
              "十一．", "十二．", "十三．", "十四．", "十五．",
            ],
            cnums:["一","二","三","四","五","六","七","八","九","十","十一","十二","十三","十四","十五"],
            /* 卷参设置 */
            paperMode:0, // 0-简易 1-普通 2-正式
            paramCollapse:false,
            optSubTitle:false, // 副标题
            optTestInfo:false, // 试卷信息
            optStudentInfo:false, // 考生信息
            optPart:false, // 分卷及注释
            optScore:false, // 总分栏
            optCateScore:false, // 大题评分区
            optSeal:false, // 装订线
            optNotice:false, // 注意事项
            optMarkTag:false, // 保密标记
            editingField:'', // 当前编辑中的文本域
            areaRows:{}, // 每题作答区行数 { sid: 行数 }
            paperForm:{
                basketId:"", // 试题篮ID
                paperSubject:"", // 试卷学科
                paperName:"", // 试卷名称
                isOpen:0,// 0-不公开 1-公开
                times:0, // 考试时长
                groups: [], // 大题分组，查询试题篮后自动整合，示例：{ Key: "一、选择题", Value: [{ SID: "试题SID", Seq: 1, Score: 5 }] }
                /* 卷参 */
                subTitle:"", // 副标题（勾选后才赋默认值）
                testInfo:"", // 试卷信息（勾选后才赋默认值）
                studentInfo:"", // 考生信息（勾选后才赋默认值）
                partHeadList: [], //分卷及注释（勾选后才赋默认值，最多支持分两卷），内外两层List长度最多为2，内层List表示分卷标题、说明文字，示例："第Ⅰ卷（选择题）", "请点击修改第I卷的文字说明" ],[ "第Ⅱ卷（非选择题）","请点击修改第Ⅱ卷的文字说明" ]]
                partHeadSeq: 0, //大题序号（判断从哪道大题开始分卷）
                score: 0,  //总分栏（1：展示、0：不展示）
                cateScore: 0, // 大题评分区（1：展示、0：不展示）
                notice: "", //注意事项（勾选后才赋默认值）
                seal: 0, //装订线（1：展示、0：不展示）
                markTag: "", // 保密标记（勾选后才赋默认值）
                /* 答题区域设置 */
                quesAreas: [] // 示例：{ Key: "试题SID", Value: 3 }（Value 为作答区行数）
            },
            /* 卷参默认值（勾选对应项时赋予） */
            paperParamDefaults:{
                subTitle: "试卷副标题",
                testInfo: "考试范围：xxx；考试时间：100分钟；命题人：xxx",
                studentInfo: "学校：___________　姓名：___________　班级：___________　考号：___________",
                notice: "1．答题前填写好自己的姓名、班级、考号等信息2．请将答案正确填写在答题卡上",
                markTag: "绝密★启用前",
                partHeadList: [
                    [
                        "第Ⅰ卷（选择题）",
                        "请点击修改第I卷的文字说明"
                    ],
                    [
                        "第Ⅱ卷（非选择题）",
                        "请点击修改第Ⅱ卷的文字说明"
                    ]
                ]
            },
            paperFormRules:{
                paperName: [{ required: true, message: "请输入组卷名称", trigger: "change" },],
                times: [{ required: true, validator: this.checkPaperTime }],
            },
            downloadPaper:{
                paperId:'',
                method:7,
                docx:1, // docx
                size:1,
            },
            paperList:[],
        };
    },
    computed: {
        isOpenBool: {
            get() {
                return this.paperForm.isOpen === 1;
            },
            set(v) {
                this.paperForm.isOpen = v ? 1 : 0;
            }
        },
        // sid -> ques 映射
        quesMap() {
            const map = {};
            this.quesClassifyList.forEach(c => {
                (c.quesList || []).forEach(item => { map[item.ques.sid] = item.ques; });
            });
            return map;
        },
        // 试卷总分
        totalScore() {
            let sum = 0;
            this.paperForm.groups.forEach(g => g.Value.forEach(q => { sum += Number(q.Score) || 0; }));
            return sum;
        },
        // 整卷难度（按难度系数均值换算）
        paperDegree() {
            const qs = Object.values(this.quesMap).filter(q => q.degree !== undefined && q.degree !== null && q.degree !== '');
            if (!qs.length) return '中';
            const avg = qs.reduce((s, q) => s + Number(q.degree), 0) / qs.length;
            return this.degreeLabel(avg);
        },
        // 注意事项分行
        noticeList() {
            return (this.paperForm.notice || '').split(/(?=\d[．.])/).filter(s => s.trim());
        }
    },
    created() {
        if (this.$route.query.sen&&this.$route.query.sp) {
            this.sp = this.$route.query.sp;
            this.subjectEnName = this.$route.query.sen;
            this.paperForm.paperSubject = this.$route.query.sen;
            this.queryBasketInfo();
            this.queryPaperList();
        }
    },
    mounted() {
    },
    activated() {
    },
    watch: {
        optSubTitle() { this.syncPaperParams(); },
        optTestInfo() { this.syncPaperParams(); },
        optStudentInfo() { this.syncPaperParams(); },
        optPart() { this.syncPaperParams(); },
        optNotice() { this.syncPaperParams(); },
        optMarkTag() { this.syncPaperParams(); },
    },
    methods: {
        checkPaperTime(rule, value, callback){
            if (!this.paperForm.times || this.paperForm.times<=0) {
                callback(new Error('开始时长时间不合法'))
            } else {
                callback();
            }
        },
        backExamPaper(path){
            this.$router.push(path+'?sp='+this.sp);
        },
        // 查询试题篮
        queryBasketInfo(){
            queryBasket({ subjectEnName: this.subjectEnName }).then(res => {
                if (res.data.code === 1) {
                    this.loading = false;
                    this.basketInfo = res.data.data;
                    this.paperForm.basketId = this.basketInfo.basketId;
                    this.basketQuesCount = this.basketInfo.quesCount;
                    this.basketQuesIds = this.basketInfo.quesIds;
                    this.quesClassifyList = this.basketInfo.qcList;
                    this.buildPaperGroups();
                }else {
                    this.loading = false;
                }
            });
        },
        // 试题篮信息整合为组卷分组
        buildPaperGroups(){
            this.rebuildGroups();
            // 默认试卷名称
            if (!this.paperForm.paperName) {
                const d = new Date();
                const pad = n => String(n).padStart(2, '0');
                const rand = String(Math.floor(Math.random() * 9e10) + 1e10);
                const subjectName = this.basketInfo.subjectName || '';
                this.paperForm.paperName = `${d.getFullYear()}年${pad(d.getMonth() + 1)}月${pad(d.getDate())}日${rand}的${subjectName}组卷`;
            }
        },
        // 按当前试题顺序重建分组（保留已设置的分值）
        rebuildGroups(){
            const scoreMap = {};
            this.paperForm.groups.forEach(g => g.Value.forEach(q => { scoreMap[q.SID] = q.Score; }));
            const groups = [];
            let seq = 1;
            this.quesClassifyList.forEach((cate, i) => {
                const value = (cate.quesList || []).map(item => ({
                    SID: item.ques.sid,
                    Seq: seq++,
                    Score: scoreMap[item.ques.sid] !== undefined ? scoreMap[item.ques.sid] : this.defaultScore()
                }));
                if (value.length > 0) {
                    groups.push({ Key: (this.cnums[i] || '') + '、' + cate.quesCateName, Value: value });
                }
            });
            this.paperForm.groups = groups;
            // 默认从第一个非选择题大题开始分第Ⅱ卷
            const idx = this.quesClassifyList.findIndex(c => !(c.quesCateName || '').includes('选择'));
            this.paperForm.partHeadSeq = idx > 0 ? idx : 0;
        },
        // 上移/下移试题（不可跨大题）
        moveQues(gi, qi, dir){
            const list = this.quesClassifyList[gi].quesList;
            const target = qi + dir;
            if (target < 0 || target >= list.length) return;
            const item = list.splice(qi, 1)[0];
            list.splice(target, 0, item);
            this.rebuildGroups();
        },
        // 删除试题（从试题篮移除）
        removeQues(gi, qi){
            const cate = this.quesClassifyList[gi];
            const item = cate.quesList[qi];
            this.$confirm('确定从组卷中删除该试题？', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                quesDelBasket({ ques: item.ques, basketSubject: this.subjectEnName }).then(res => {
                    if (res.data.code === 1) {
                        this.$message.info('试题已移除');
                        delete this.areaRows[item.ques.sid];
                        cate.quesList.splice(qi, 1);
                        cate.quesCount = Math.max(0, (cate.quesCount || 0) - 1);
                        this.basketQuesCount = Math.max(0, this.basketQuesCount - 1);
                        if (cate.quesList.length === 0) {
                            this.quesClassifyList.splice(gi, 1);
                        }
                        this.rebuildGroups();
                        this.syncQuesAreas();
                    } else {
                        this.$message.error('请求出错');
                    }
                });
            }).catch(() => {});
        },
        // 默认分值
        defaultScore(){
            return 0;
        },
        // 定位试题所属分组的分数项
        findGroupQues(sid){
            for (const g of this.paperForm.groups) {
                const hit = g.Value.find(q => q.SID === sid);
                if (hit) return hit;
            }
            return { SID: sid, Seq: 0, Score: 0 };
        },
        // 全卷连续题号
        quesGlobalSeq(gi, qi){
            let n = 0;
            for (let i = 0; i < gi; i++) n += (this.quesClassifyList[i].quesList || []).length;
            return n + qi + 1;
        },
        // 大题满分
        groupFullScore(gi){
            const g = this.paperForm.groups[gi];
            if (!g) return 0;
            return g.Value.reduce((s, q) => s + (Number(q.Score) || 0), 0);
        },
        // 大题每小题分值（分值一致时展示）
        groupEveryScore(gi){
            const g = this.paperForm.groups[gi];
            if (!g || !g.Value.length) return '';
            const first = Number(g.Value[0].Score) || 0;
            const same = g.Value.every(q => (Number(q.Score) || 0) === first);
            return same ? `，每小题${first}分` : '';
        },
        // 大题标题（满分为0时只显示题目数）
        groupTitleText(gi){
            const cate = this.quesClassifyList[gi] || {};
            let text = `${this.quesNoList[gi] || ''}${cate.quesCateName || ''}（共${cate.quesCount || 0}小题`;
            if (this.groupFullScore(gi) > 0) {
                text += `，满分${this.groupFullScore(gi)}分${this.groupEveryScore(gi)}`;
            }
            return text + '）';
        },
        // 同步作答区行数到 paperForm.quesAreas
        syncQuesAreas(){
            const areas = [];
            Object.keys(this.areaRows).forEach(sid => {
                const rows = Number(this.areaRows[sid]) || 0;
                if (rows > 0) areas.push({ Key: sid, Value: rows });
            });
            this.paperForm.quesAreas = areas;
        },
        // 卷参勾选状态同步：不勾选置空，勾选且为空时赋默认值
        syncPaperParams(){
            const f = this.paperForm, d = this.paperParamDefaults;
            f.subTitle = this.optSubTitle ? (f.subTitle || d.subTitle) : '';
            f.testInfo = this.optTestInfo ? (f.testInfo || d.testInfo) : '';
            f.studentInfo = this.optStudentInfo ? (f.studentInfo || d.studentInfo) : '';
            f.notice = this.optNotice ? (f.notice || d.notice) : '';
            f.markTag = this.optMarkTag ? (f.markTag || d.markTag) : '';
            f.partHeadList = this.optPart
                ? (f.partHeadList && f.partHeadList.length ? f.partHeadList : JSON.parse(JSON.stringify(d.partHeadList)))
                : [];
        },
        // 卷参模式预设
        applyPaperMode(mode){
            if (mode === 0) { // 简易
                this.optSubTitle = false; this.optTestInfo = false; this.optStudentInfo = false;
                this.optPart = false; this.optScore = false; this.optCateScore = false;
                this.optSeal = false; this.optNotice = false; this.optMarkTag = false;
            } else if (mode === 1) { // 普通
                this.optSubTitle = true; this.optTestInfo = true; this.optStudentInfo = true;
                this.optPart = false; this.optScore = true; this.optCateScore = true;
                this.optSeal = false; this.optNotice = false; this.optMarkTag = false;
            } else { // 正式
                this.optSubTitle = true; this.optTestInfo = true; this.optStudentInfo = false;
                this.optPart = true; this.optScore = true; this.optCateScore = true;
                this.optSeal = true; this.optNotice = true; this.optMarkTag = true;
            }
        },
        startEdit(field){
            this.editingField = field;
            this.$nextTick(() => {
                const refVal = this.$refs.editInput;
                const comp = Array.isArray(refVal) ? refVal[0] : refVal;
                if (comp && comp.$el) {
                    const input = comp.$el.querySelector('input, textarea');
                    if (input) {
                        input.focus();
                        if (input.select) input.select();
                    }
                }
            });
        },
        // 一键设置大题分值
        oneKeySet(gi){
            this.$prompt('请输入统一分值', '一键设置', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^\d+(\.\d+)?$/,
                inputErrorMessage: '请输入合法分值'
            }).then(({ value }) => {
                this.paperForm.groups[gi].Value.forEach(q => { q.Score = Number(value); });
            }).catch(() => {});
        },
        degreeOf(sid){
            const q = this.quesMap[sid];
            return q ? q.degree : undefined;
        },
        degreeLabel(d){
            const v = Number(d);
            if (isNaN(v)) return '中';
            if (v >= 0.8) return '易';
            if (v >= 0.6) return '较易';
            if (v >= 0.4) return '中';
            if (v >= 0.2) return '较难';
            return '难';
        },
        openPaperInfo(){
            this.isShowPaperDialog = true;
        },
        viewPaper(){
            this.isShowPaperListDialog = true;
        },
        // 提交生成 组卷
        submitGeneratePaper(){
            if (!this.paperForm.paperName){
                this.$message.error("请填写组卷名称")
                return;
            }
            this.syncQuesAreas();
            this.syncPaperParams();
            const payload = Object.assign({}, this.paperForm, {
                score: this.optScore ? 1 : 0,
                cateScore: this.optCateScore ? 1 : 0,
                seal: this.optSeal ? 1 : 0,
                partHeadSeq: this.optPart ? this.paperForm.partHeadSeq : 0,
            });
            this.loading = true;
            generatePaper(payload).then(res => {
                if (res.data.code === 1) {
                    this.queryPaperList();
                    this.isShowPaperDialog = false;
                    this.loading = false;
                }else {
                    this.loading = false;
                    this.$message.error("请求出错")
                }
            });
        },
        // 查询组卷
        queryPaperList(){
            listPaper().then(res => {
                if (res.data.code === 1) {
                    this.paperList = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            });
        },
        // 下载组卷
        downloadPaperFile(item){
            this.downloadPaper.paperId = item.paperId;
            downloadPaper(this.downloadPaper).then(res => {
                if (res.data.code === 1) {
                    downloadFile(res.data.data,item.paperName);
                }else {
                    this.$message.error("请求出错")
                }
            });
        },
    }
};
</script>
<style lang="scss" scoped>
.base-exam-container{
    width: 100%;
    height: 100%;
    overflow-y: auto!important;
    overflow-x: hidden;
    background-color: #f5f5f5;
}
.base-exam-box {
    width:100%;
    height: auto;
    overflow-y: auto!important;
}
.paper-head-box{
    width: 100%;
    height: 52px;
}
.paper-head-container{
    height: 50px;
    width: 100%;
    line-height: 48px;
    box-shadow: 0 1px 12px 0 rgba(0, 58, 129, 0.08);
    background-color: #fff;
    display: flex;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
}
.l-side-paper-container{
    width: 60px;
    height: 50px;
}
.r-side-paper-container{
    width: 60px;
    height: 50px;
}
.mid-paper-container{
    width: calc(100% - 120px);
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    color: #ff7f2e;
    font-weight: bold;
    font-family: sans-serif;
    text-align: center;
}
.exam-container{
    width: 100%;
    height: auto;
    margin: auto;
    display: flex;

}
.l-exam-container{
    width: calc(100% - 300px);
    height: auto;
    background-color: #fff;
    padding: 0 30px 30px 30px;
    box-sizing: border-box;
    margin-top: 10px;
    position: relative;
}
.seal-line-img{
    position: absolute;
    left: 10px;
    top: 130px;
    width: 60px;
    height: auto;
}
.l-exam-container.seal-on{
    padding-left: 80px;
}
.paper-mark-tag{
    color: #ff7f2e;
    font-weight: bold;
    font-size: 15px;
    padding-top: 15px;
}
.paper-sub-title{
    text-align: center;
    color: #333333;
    padding: 6px 0;
}
.paper-test-info{
    text-align: center;
    color: #333333;
    padding: 6px 0;
}
.paper-student-info{
    text-align: center;
    color: #333333;
    padding: 6px 0;
}
.edit-input{
    width: 70%;
    margin: 0 auto;
}
.edit-input :deep(.el-input__inner){
    text-align: center;
}
.note-edit-input{
    width: 100%;
}
.note-edit-input :deep(.el-input__inner){
    text-align: left;
}
.title-edit-input{
    font-size: 16px;
}
.total-score-box{
    display: flex;
    justify-content: center;
    padding: 10px 0;
}
.score-table{
    border-collapse: collapse;
}
.score-table td{
    border: 1px solid #333333;
    min-width: 60px;
    height: 26px;
    text-align: center;
    font-size: 13px;
    color: #333333;
    padding: 0 10px;
}
.paper-notice{
    color: #333333;
    font-size: 14px;
    padding: 8px 0;
    line-height: 24px;
}
.part-head-title{
    text-align: center;
    background-color: #eeeeee;
    height: 44px;
    line-height: 44px;
    font-size: 16px;
    color: #333333;
    margin-top: 20px;
}
.part-head-note{
    color: #666666;
    font-size: 13px;
    padding: 8px 0;
}
.exam-list-container{
    width: 100% ;
    padding: 0 0 0 0;
    margin: auto;
    box-sizing: border-box;
    height: auto;
}
.exam-item{
    width: 100%;
    height: auto;
    margin-top: auto;
    margin-bottom: 10px;
    border-radius: 5px;
    border: 1px solid #dadada;
    cursor: pointer;
}
.exam-item:hover{
    border: 1px solid #ff7f2e!important;
    border-radius: 5px;
}
.answer-area{
    padding: 4px 12px 10px 12px;
}
.answer-line{
    height: 32px;
    border-bottom: 1px dashed #999999;
}
.ques-hover-bar{
    display: none;
    align-items: center;
    justify-content: flex-end;
    padding: 8px 12px;
    border-top: 1px dashed #eeeeee;
}
.exam-item:hover .ques-hover-bar{
    display: flex;
}
.bar-btn{
    font-size: 13px;
    color: #ff7f2e;
    margin-left: 12px;
    cursor: pointer;
}
.bar-btn:hover{
    text-decoration: underline;
}
.bar-btn-danger{
    color: #f56c6c;
}
.bar-btn-disabled{
    color: #c0c4cc;
    cursor: not-allowed;
}
.bar-btn-disabled:hover{
    text-decoration: none;
}
.bar-unit{
    font-size: 13px;
    color: #ff7f2e;
    margin-left: 4px;
    margin-right: 10px;
}
.bar-label{
    font-size: 13px;
    color: #ff7f2e;
    margin-right: 4px;
}
.exam-title-container{
    width: 100%;
    min-height: 50px;
    color: #333333;
    line-height: 50px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    padding-top: 10px;
}
.exam-classify-title{
    width: 100%;
    min-height: 40px;
    line-height: 40px;
    font-weight: bold;
    font-size: 14px;
    color: #333333;
}
.cate-score-table{
    display: inline-table;
    border-collapse: collapse;
    margin-right: 15px;
    vertical-align: middle;
}
.cate-score-table td{
    border: 1px solid #333333;
    min-width: 55px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    font-size: 12px;
    font-weight: normal;
    color: #333333;
}

.r-exam-container{
    width: 280px;
    height: auto;
    margin-left: 20px;
    margin-top: 10px;
}
.exam-submit-container{
    width: 100%;
    height: 60px;
    padding: 11px 0 11px 0;
    box-sizing: border-box;
    background-color: #fff;

}
.exam-submit-btn{
    width: 240px;
    height: 38px;
    background: #ff7f2e;
    color: #fff;
    border-radius: 5px;
    font-size: 14px;
    align-items: center;
    justify-content: center;
    display: flex;
    margin: auto;
    cursor: pointer;
}
.plain-btn{
    background: #fff;
    color: #ff7f2e;
    border: 1px solid #ff7f2e;
}
.r-panel{
    width: 100%;
    background-color: #fff;
    margin-top: 10px;
    padding: 12px 15px;
    box-sizing: border-box;
}
.r-panel-title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    font-weight: bold;
    color: #333333;
}
.title-bar{
    border-left: 4px solid #ff7f2e;
    padding-left: 8px;
}
.r-panel-body{
    margin-top: 10px;
}
.paper-stat{
    color: #666666;
    font-size: 13px;
    display: flex;
    align-items: center;
}
.paper-stat-score{
    margin-left: 15px;
}
.score-set-link{
    color: #ff7f2e;
    font-size: 13px;
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 4px;
}
.collapse-btn{
    color: #ff7f2e;
    font-size: 13px;
    font-weight: normal;
}
.param-check-list{
    margin-top: 10px;
    display: grid;
    grid-template-columns: 1fr 1fr;
}
.param-check-list .el-checkbox{
    margin-right: 0;
}
.score-dialog-head{
    text-align: center;
    margin-bottom: 12px;
    color: #333333;
}
.score-group{
    margin-bottom: 14px;
}
.score-group-title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    color: #333333;
    margin-bottom: 6px;
}
</style>
